export const CLIENT_ALL = "CLIENT_ALL";
export const APPOINTMENT_PROVIDER_ALL = "APPOINTMENT_PROVIDER_ALL";
export const APPOINTMENT_CREATE = "APPOINTMENT_CREATE";
export const ALLOW_PROVIDERS = "ALLOW_PROVIDERS";

export const APPOINTMENT_TODAY = "APPOINTMENT_TODAY";
export const APPOINTMENT_UPCOMING = "APPOINTMENT_UPCOMING";
export const APPOINTMENT_REQUEST = "APPOINTMENT_REQUEST";
export const APPOINTMENT_PAYMENT = "APPOINTMENT_PAYMENT";
export const APPOINTMENT_ACCEPT = "APPOINTMENT_ACCEPT";
export const APPOINTMENT_CANCEL = "APPOINTMENT_CANCEL";
export const APPOINTMENT_PAID = 'APPOINTMENT_PAID';
export const APPOINTMENT_LIST_ALL = "APPOINTMENT_LIST_ALL";
export const APPOINTMENT_GET = "APPOINTMENT_GET";
export const APPOINTMENT_JOIN = "APPOINTMENT_JOIN";
export const APPOINTMENT_JOIN_MSG = "APPOINTMENT_JOIN_MSG";
export const APPOINTMENT_EDIT = 'APPOINTMENT_EDIT';
export const APPOINTMENT_DELETE = "APPOINTMENT_DELETE";
export const APPOINTMENT_EVENT = "APPOINTMENT_EVENT";

export const DRAG_UPDATE = "DRAG_UPDATE";
export const GET_DRAG = "GET_DRAG";

export const REQUEST_INFO = "REQUEST_INFO";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const RESET_REQUEST = "RESET_REQUEST";
export const CLIENT_INFO = "CLIENT_INFO";
export const PROVIDERS_ID = "PROVIDERS_ID";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const CLIENT_FULL = "CLIENT_FULL";
export const SHOW_FORGOT_PASSWORD = "SHOW_FORGOT_PASSWORD";
export const USERS = "USERS";
export const LAST_MESSAGES = "LAST_MESSAGES";
export const MSG_LEAVE_PRACTICE = "MSG_LEAVE_PRACTICE";
/**
 * Document
 */
export const RECIPIENT_ALL = "RECIPIENT_ALL";
export const SENDER_ALL = "SENDER_ALL";
export const FILE_SHARE = "FILE_SHARE";
export const RECENT_DOCUMENT = "RECENT_DOCUMENT";

/**
 * miscellaneous
 */
export const SHOW_SPINNING = "SHOW_SPINNING";
/**
 *  Article
 */
export const POST_ARTICLE = "POST_ARTICLE";
export const PUBLISHED_ALL = "PUBLISHED_ALL";
export const ARTICLES_ALL = "ARTICLES_ALL";
export const ARTICLE_DETAILS = 'ARTICLE_DETAILS';
export const ARTICLE_DELETE = "ARTICLE_DELETE";
export const CATEGORY_LIST = "CATEGORY_LIST";
export const UPDATE_ARTICLE = "UPDATE_ARTICLE";
export const ARTICLE_DETAILS_DISPLAY = "ARTICLE_DETAILS_DISPLAY";
export const CATEGORY_ADD = "CATEGORY_ADD";
export const POST_COMMENT = "POST_COMMENT";
export const GET_COMMENT_BYID = "GET_COMMENT_BYID";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";

/**
 * Messages
 */
export const MESSAGES_LIST = "MESSAGES_LIST";
export const MESSAGES_LIST_ERROR = "MESSAGES_LIST_ERROR";
export const MESSAGES = "MESSAGES";
export const MESSAGES_ONE_ERROR = "MESSAGES_ONE_ERROR";
export const MESSAGES_EDIT = "MESSAGES_EDIT";

/**
 * chatbot
 */
export const CHATBOT_PAGE = "CHATBOT_PAGE";
export const CHATBOT_ADD = "CHATBOT_ADD";
export const CHATBOT_ADD_MESSAGE = "CHATBOT_ADD_MESSAGE";
export const CHATBOT_DELETE_MESSAGE = "CHATBOT_DELETE_MESSAGE";
export const CHATBOT_ERROR = "CHATBOT_ERROR";
export const GET_CHATBOT = 'GET_CHATBOT';
export const GET_REPLY = "GET_REPLY";
export const GET_FAIL = "GET_FAIL";

export const CLIENT_MUSIC_BACKGROUND = "CLIENT_MUSIC_BACKGROUND";

export const INFO_UPDATE = "INFO_UPDATE";

export const PRACTICE_LIST = "PRACTICE_LIST";